/**
 * Converts a given number of bytes into gigabytes (GB).
 *
 * This function takes a numeric value representing a quantity in bytes and converts it
 * to gigabytes by dividing by 1,073,741,824 (which is 1024³, the number of bytes in 1 GB).
 * If the provided value is undefined or falsy, the function returns 0.
 *
 * @param bytes - The total space used in bytes.
 * @returns The equivalent space in gigabytes.
 */
export function convertToGB(bytes: number | undefined): number {
    return bytes ? Math.round((bytes / 1073741824) * 100) / 100 : 0
}
